import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard, ConfigModule, RoutingConfig } from '@spartacus/core';
import { CmsPageGuard, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrCustomerSearchModule } from './components/kn-br-customer-search/kn-br-customer-search.module';
import { AtgNoB2BUnitPageModule } from './components/kn-br-customer-search/atg-no-b2b-unit-page/atg-no-b2b-unit-page.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    KnBrCustomerSearchModule,
    AtgNoB2BUnitPageModule,
    RouterModule.forChild([
      {
        data: { pageLabel: 'atgCustomerHomepage', cxRoute: 'home' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
      },
      {
        path: 'no-b2b-units',
        canActivate: [CmsPageGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          home: {
            paths: [''],
          },
        },
      },
    } as RoutingConfig),
  ],
})
export class KnBrHomeModule {}
